function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M480,191.962h-47.061V82.5c0-5.522-4.478-10-10-10H10c-5.523,0-10,4.478-10,10v276.751c0,5.522,4.477,10,10,10h170.673 V397.5H158c-5.523,0-10,4.478-10,10c0,5.523,4.477,10,10,10h123.556c5.523,0,10-4.477,10-10c0-5.522-4.477-10-10-10h-22.672 v-28.249h57.47V407.5c0,5.523,4.478,10,10,10H480c5.522,0,10-4.477,10-10V201.962C490,196.439,485.522,191.962,480,191.962z  M470,349.251H336.354V211.962H470V349.251z M412.939,92.5v99.462h-86.586c-5.522,0-10,4.477-10,10v70.046H20V92.5H412.939z  M238.884,397.5h-38.211v-28.249h38.211V397.5z M20,349.251v-57.243h296.354v57.243H20z M336.354,397.5v-28.249H470V397.5H336.354z "
}), React.createElement("circle", {
  cx: 403.177,
  cy: 383.375,
  r: 6.682
}), React.createElement("circle", {
  cx: 216.47,
  cy: 318.583,
  r: 8.353
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgIcon1 = function SvgIcon1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon1.c8ae7fc3.svg";
export { ForwardRef as ReactComponent };